export default {
    components: {
        BaseTable: {
            emptyText: "Ingen data hittades"
        },
        ContentEdit: {
            program: {
                title: "Om träningsprogrammet"
            },
            category: {
                title: "Om träningskategorin"
            },
            massage: {
                title: "Om massageprogrammet"
            },
            default: {
                title: "Om platshållaren"
            },
            textFieldsInfo:
                "Alla <em>textfält</em> i denna ruta representerar innehåll som visas i stolens gränssnitt.",
            publishState: {
                title: "Publiceringsstatus (för valt språk)",
                notPublished: "Ej publicerad",
                test: "Testmiljö",
                published: "Publicerad"
            }
        },
        InputDropzone: {
            dragActiveLabel: "Släpp ljudfilen här",
            dragInactiveLabel:
                "Dra och släpp en ljudfil här eller klicka för att bläddra"
        },
        LanguageTabs: {
            edited: "Redigerad",
            unchanged: "Oförändrad",
            incomplete: "Ofullständig"
        },
        ModalCancel: {
            description:
                "Är du säker på att du vill avbryta? Alla ändringar kommer att förloras."
        },
        ModalConfirmChanges: {
            title: "Bekräfta ändringar",
            description: "Du är på väg att spara följande ändringar:",
            change: "Ändra {field} till \"{value}\"",
            was: "var \"{value}\"",
            noChanges: "Inga ändringar att spara."
        },
        PreviewAudio: {
            uploadFailed: "Det gick inte att ladda ljudfilen för {audio}",
            unsupportedBrowser: "Din webbläsare stöder inte ljuduppspelning.",
            default: "Förvald"
        },
        PreviewImage: {
            uploadFailed: "Det gick inte att ladda bildfilen"
        },
        TimelineBlock: {
            type: {
                neck: "N",
                back: "R",
                legs: "B"
            }
        },
        TimelineEditor: {
            blocks: {
                title: "Block"
            },
            timeline: {
                title: "Tidslinje",
                mismatchingBlocks: "{count} block passar inte",
                totalTimeSeconds: "{seconds}s",
                totalTimeMinutes: "{minutes}m{seconds}s"
            }
        },
        OperatingTime: {
            title: "Körtid",
            headers: {
                duration: "Tid",
                hours: "I timmar",
                minutes: "I minuter",
                seconds: "I sekunder"
            },
            fields: {
                lifetime: "Livstid",
                total: "Totalt",
                xMotor: "X-motor",
                yMotor: "Y-motor",
                zMotor: "Z-motor",
                leftMassage: "Vänster Massage",
                rightMassage: "Höger Massage",
                tiltMotor: "Lutningsmotor",
                legTilt: "Benvinkling",
                legMassage: "Benmassage",
                neckMassage: "Nackmassage",
                heatPad: "Värmedyna"
            }
        }
    },
    layout: {
        ContentLayout: {
            content: {
                title: "Innehåll",
                nav: {
                    categories: "Kategorier",
                    programs: "Träningsprogram",
                    massages: "Massageprogram",
                    static: "Statiska sidor",
                    uicomponents: "UI-komponenter"
                }
            },
            app: {
                title: "App"
            },
            chairs: {
                title: "Stolar"
            },
            default: {
                title: "Platshållare"
            }
        },
        pages: {
            settings: {
                title: "Inställningar",
                adminTab: "Inställningar",
                saved: "Inställningen sparades",
                fields: {
                    admin_pin: "Admin-PIN",
                    admin_pin_description: "Lösenord för att öppna plattans serviceläge.",
                    max_screen_brightness: "Max skärmljusstyrka",
                    max_screen_brightness_description: "Ljusstyrka för skärmen när den är aktiv (värde mellan 0 och 1).",
                    ota_active_version: "Aktiv app-version (OTA)",
                    ota_active_version_description: "Standard app-version som alla stolar ska ha, om ingen override är vald.",
                    last_online_minute_threshold: "Offline-tröskel (minuter)",
                    last_online_minute_threshold_description: "Hur många minuter det får gå utan kontakt med API:et innan plattan anses vara offline.",
                    command_max_check_count: "Max antal ACK-kontroller",
                    command_max_check_count_description: "Hur många gånger appen kontrollerar efter ett ACK innan kommandot skickas om.",
                    command_max_resend_count: "Max antal omsändningar",
                    command_max_resend_count_description: "Hur många gånger ett kommando skickas om innan programmet avbryter kommunikationen.",
                    command_queue_timer_interval_ms: "ACK-kontrollintervall (ms)",
                    command_queue_timer_interval_ms_description: "Hur många millisekunder appen väntar mellan varje ACK-kontroll.",
                    event_log_limit: "Händelselogggräns",
                    event_log_limit_description: "Hur många händelseloggar som visas i plattan."
                },
                databaseKey: "Databasnyckel",
                unknownSetting: "Okänd inställning",
                otaConfirmTitle: "Ändra aktiv app-version",
                otaConfirmBody: "Du håller på att ändra standard app-versionen för alla stolar. Ändringen träder i kraft nästa gång stolarna synkroniserar.",
                otaConfirmNote: "Obs: Stolar med en individuell versions-override kommer fortsätta använda sin override och påverkas inte av denna ändring.",
                validation: {
                    mustBeNumber: "Måste vara ett tal.",
                    mustBeInteger: "Måste vara ett heltal.",
                    minValue: "Minsta tillåtna värde är {min}.",
                    maxValue: "Högsta tillåtna värde är {max}.",
                    minLength: "Måste vara exakt {min} tecken.",
                    maxLength: "Får inte vara längre än {max} tecken."
                }
            },
            invites: {
                title: "Inbjudningar",
                adminTab: "Inbjudningar",
                renew: "Vill du förnya inbjudan och skicka ett nytt e-postmeddelande?",
                delete: "Vill du radera inbjudan?",
                errorRequirements: "Du måste ange en e-postadress och roll",
                roles: "Roller",
                allRoles: "Alla roller",
                noInvites: "Inga inbjudningar hittades",
                send: "Skicka inbjudan"
            },
            users: {
                title: "Användare",
                adminTab: "Användare",
                noUsers: "Inga användare hittades",
                editUser: "Redigera",
                deleteUser: "Radera användare",
                confirmDelete: "Är du säker på att du vill radera \"{name}\"?"
            },
            chairsDetails: {
                markedAsFixed: "{errorCode} markerad som åtgärdad",
                markAsFixed: "Markera som åtgärdad",
                errorLog: "Fellogg",
                toFix: "Att åtgärda",
                fixed: "Åtgärdad",
                viewEventLogs: "Visa event logs",
                contentTree: "Innehållsträd"
            },
            chairEventLogs: {
                title: "Event logs",
                empty: "Inga event logs hittades.",
                clearLogs: "Töm loggar",
                searchPlaceholder: "Sök på id, kommando eller värde...",
                deleted: "Alla event logs har tagits bort.",
                confirmClearTitle: "Töm event logs",
                confirmClearBody: "Är du säker på att du vill ta bort alla event logs för denna stol? Det går inte att ångra.",
                confirmClearButton: "Ja, töm loggar",
                ioFilterLabel: "Filtrera på i/o",
                ioFilter: {
                    all: "i/o: Alla"
                },
                columns: {
                    isarId: "Isar #",
                    timestamp: "Tidsstämpel",
                    io: "i/o",
                    eventId: "ID",
                    command: "Kommando",
                    value: "Värde"
                }
            },
            chairs: {
                noCustomer: "Ingen kund",
                noSeller: "Ingen säljare",
                title: "Stolar"
            },
            chairsSave: {
                create: "Skapa ny stol",
                configure: "Konfigurera stol",
                chooseSeller: "Välj säljare",
                chooseMarket: "Välj marknad",
                chooseCustomer: "Välj kund",
                chooseSector: "Välj sektor",
                chooseSegment: "Välj segment",
                chooseAreaTags: "Välj områdestagg",
                addNewCustomer: "Lägg till ny kund",
                addNewSeller: "Lägg till ny säljare",
                addNewTag: "Lägg till ny områdestagg på {market} marknaden",
                errorAreaTagExists: "Det finns redan ett område med detta namn",
                chairData: "Stoldata",
                sellerAndCustomer: "Säljare och kund",
                testChair: "Teststol",
                testChairInfo:
                    "(Denna stol kan visa opublicerat innehåll skapat av SuperAdmin)",
                modalInfo: "Detta läggs till för marknaden <strong>{market}</strong>",
                deleteChair: "Radera stol",
                confirmDelete: "Är du säker på att du vill radera \"{name}\"?"
            },
            contentCategorySave: {
                editCategory: "Redigera kategori",
                createCategory: "Skapa kategori",
                dropImage: "Släpp bilden här",
                addImage: "Lägg till bild",
                changeImage: "Ändra bild",
                selectedPrograms: "Valda träningsprogram",
                noPrograms:
                    "<strong>Dra in</strong> ett eller flera av de tillgängliga träningsprogrammen.",
                availablePrograms: "Tillgängliga träningsprogram",
                allAvailablePrograms:
                    "Alla tillgängliga träningsprogram är redan inkluderade.",
                deleteCategory: "Radera kategori",
                deleteCategoryConfirm: "Är du säker på att du vill radera \"{name}\"?"
            },
            contentMassageSave: {
                editProgram: "Redigera massageprogram",
                createNewProgram: "Skapa nytt massageprogram",
                deleteProgram: "Radera massageprogram",
                confirmDelete: "Är du säker på att du vill radera \"{name}\"?"
            },
            contentStaticSave: {
                title: "Redigera {name}"
            },
            contentTrainingSave: {
                editProgram: "Redigera träningsprogram",
                createNewProgram: "Skapa nytt träningsprogram",
                deleteProgram: "Radera träningsprogram",
                confirmDelete: "Är du säker på att du vill radera \"{name}\"?",
                uploadedAudioTracks: "Uppladdade ljudspår",
                audioTrackTooltip:
                    "Du kan endast byta namn på eller markera uppladdade ljudspår för radering",
                uploadNewAudioTracks: "Ladda upp nya ljudspår",
                addAudioFile: "Lägg till ljudfil",
                audioFileRequirements: "Max {maxSize}. {types}.",
                marketsInfo:
                    "Marknader som detta träningsprogram är tillgängligt för, välj minst en. Om Promas Global är vald kommer programmet att vara tillgängligt för alla marknader.",
                noMarketsSelectedError: "Välj minst en marknad"
            },
            contentUiComponentsSave: {
                editComponent: "Redigera {name}"
            },
            customers: {
                title: "Kunder"
            },
            customersSave: {
                editCustomer: "Redigera kund",
                createCustomer: "Skapa kund",
                createSector: "Skapa sektor",
                createSegment: "Skapa segment",
                sectorAndSegment: "Sektor och segment",
                deleteCustomer: "Radera kund",
                confirmDelete: "Är du säker på att du vill radera \"{name}\"?"
            },
            market: {
                editMarket: "Redigera marknad",
                createMarket: "Skapa marknad",
                deleteMarket: "Radera marknad",
                confirmDelete: "Är du säker på att du vill radera \"{name}\"?",
                errorAreaTagExists: "Det finns redan en områdestagg med detta namn",
                errorAreaTagRequired: "En områdestagg måste ha ett namn",
                deleteAreaTag: "Radera områdestagg",
                confirmDeleteAreaTag:
                    "Är du säker på att du vill radera områdestaggen \"{name}\"?",
                contentTree: "Innehållsträd",
                contentTreePage: {
                    overview: "Översikt",
                    requiredLanguages: "Språk som marknaden kräver",
                    primary: "primärt",
                    categories: "Kategorier",
                    programs: "Träningsprogram",
                    categoryTexts: "Kategoritexter",
                    programTexts: "Programtexter",
                    massagePrograms: "Massageprogram",
                    noMassagePrograms: "Inga massageprogram",
                    uncategorized: "Utan kategori",
                    isTest: "Test",
                    expandAll: "Expandera alla",
                    collapseAll: "Fäll ihop alla",
                    categoryLabel: "Kategori",
                    programLabel: "Träningsprogram",
                    massageLabel: "Massageprogram",
                    chairContextTitle: "Innehåll visas för denna stol",
                    testChair: "Teststol",
                    productionChair: "Produktionsstol",
                    scopeLabel: "Visar",
                    scopeProduction: "Endast publicerat innehåll (grönt)",
                    scopeStaging: "Publicerat och testinnehåll (grönt + orange)",
                    noContent:
                        "Inga träningsprogram är kopplade till den här marknaden.",
                    state: {
                        visible: "Visas",
                        test_only: "Endast teststolar",
                        hidden: "Dold"
                    },
                    textStatus: {
                        published: "Publicerad",
                        test_only: "Endast teststolar",
                        unpublished: "Opublicerad",
                        missing: "Saknas"
                    },
                    legend: {
                        visible: "Visas på alla stolar",
                        test_only: "Visas endast på teststolar",
                        hidden: "Visas inte",
                        note: "Teststolar (staging) visar innehåll från publiceringsnivå 1. Vanliga stolar kräver nivå 2."
                    },
                    reasons: {
                        missing_category_text:
                            "Kategorin saknar text på: {languages}",
                        no_qualifying_program:
                            "Inget träningsprogram uppfyller marknadens krav (saknar text på något språk)",
                        only_test_programs:
                            "Endast program som visas på teststolar",
                        no_visible_programs:
                            "Inga synliga träningsprogram – kategorin blir tom",
                        uncategorized:
                            "Program utan kategori skickas inte till appen",
                        missing_program_text:
                            "Saknar programtext på: {languages}",
                        program_text_unpublished:
                            "Programtext opublicerad (nivå 0) på: {languages}",
                        program_text_test_only:
                            "Programtext endast för teststolar (nivå 1) på: {languages}",
                        no_visible_massage_programs: "Inga synliga massageprogram",
                        only_test_massage_programs:
                            "Endast massageprogram för teststolar",
                        missing_massage_text:
                            "Massageprogrammet saknar text på: {languages}",
                        massage_test_only:
                            "Markerat som test för det här programmet (endast teststolar)"
                    }
                }
            },
            sellers: {
                editSeller: "Redigera säljare",
                createSeller: "Skapa säljare",
                deleteSeller: "Radera säljare",
                confirmDelete: "Är du säker på att du vill radera \"{name}\"?",
                chooseMarket: "Välj marknad"
            },
            invite: {
                inviteToFor: "{email} har blivit inbjuden till rollen som {role}."
            },
            docs: {
                installation: {
                    title: "Installationsguide",
                    description: "Steg-för-steg-guide för att installera surfplattan."
                },
                guide: {
                    title: "Serviceguide",
                    description: "Guide för att serva och underhålla stolen."
                },
                addCustomer: {
                    title: "Lägg till ny kund",
                    description:
                        "Så lägger du till en kund från Upsales i admin och ger användarna tillgång till Reload Hub."
                },
                issues: {
                    title: "Ärendelogg",
                    description: "Direktlänk till Excel med ärenden."
                },
                hanzaLog: {
                    title: "Hanza-logg",
                    description: "Direktlänk till Hanzas produktionslogg."
                },
                errorCodes: {
                    title: "Felkoder & Serviceblock",
                    description: "Version 22"
                }
            }
        },
        label: {
            appVersion: "App-version",
            areas: "Områdestaggar",
            allAreas: "Alla områdestaggar",
            createdAt: "Skapad",
            customer: "Kund",
            customers: "Kunder",
            allCustomers: "Alla kunder",
            description: "Beskrivning",
            body: "Brödtext",
            error_code: "Felkodsprefix",
            email: "E-post",
            errorCode: "Felkod",
            errorDefinition: "Definition",
            firmwareVersion: "Firmware-version",
            fixedAt: "Åtgärdad",
            isStaging: "Är test",
            lastOnline: "Senast online",
            batteryLevel: "Batterinivå",
            androidVersion: "Android-version",
            device: "Enhet",
            location: "Plats",
            market: "Marknad",
            markets: "Marknader",
            allMarkets: "Alla marknader",
            selectMarket: "Välj marknad",
            noMarket: "Ingen marknad",
            portalCustomer: "Reload Hub kund",
            noPortalCustomer: "Ingen Reload Hub kund",
            upsalesCompany: "Företag från Upsales",
            noUpsalesCompany: "Inget företag från Upsales",
            portalCustomerTaken: "kopplad till {name}",
            portalCustomerTakenGeneric: "redan kopplad",
            portalCustomerDisabled: "åtkomst avstängd",
            portalCustomerNoUsers: "inga användare än",
            name: "Namn",
            addName: "Lägg till namn",
            role: "Roll",
            roles: "Roller",
            allRoles: "Alla roller",
            seller: "Säljare",
            sellers: "Säljare",
            serial: "Serienummer",
            title: "Titel",
            token: "Token",
            type: "Typ",
            url: "Länk",
            sector: "Sektor",
            selectSector: "Välj sektor",
            allSectors: "Alla sektorer",
            segment: "Segment",
            selectSegment: "Välj segment",
            allSegments: "Alla segment",
            internalName: "Internt namn",
            image: "Bild",
            recommendedChoice: "Rekommenderat val",
            testEnvironment: "Testmiljö",
            massagePrograms: "Massageprogram",
            primaryLanguage: "Primärt språk",
            namePlaceholder: "Namn Efternamn",
            password: "Lösenord",
            confirmPassword: "Bekräfta lösenord",
            passwordRequirements: "Lösenordet måste vara minst 8 tecken långt.",
            notSelected: "Ej vald",
            searchBySerial: "Sök efter serienummer",
            status: "Status",
            allStatuses: "Alla statusar",
            isOnline: "Online",
            isOffline: "Offline",
            onlineStatus: "Onlinestatus",
            allOnlineStatuses: "Alla stolar",
            state: "Tillstånd",
            allStates: "Alla tillstånd",
            defaultAppVersion: "Standard-appversion",
            availableLanguages: "Tillgängliga språk",
            showOnlyWithSerial: "Visa endast med serienummer",
            languages: "Språk"
        },
        common: {
            deny: "Neka",
            accept: "Acceptera",
            promas: "Promas Admin",
            edit: "Redigera",
            create: "Skapa",
            save: "Spara",
            saveChanges: "Spara ändringar",
            add: "Lägg till ny",
            confirm: "Bekräfta",
            cancel: "Avbryt",
            delete: "Radera",
            close: "Stäng",
            yes: "Ja",
            no: "Nej",
            logout: "Logga ut",
            login: "Logga in",
            back: "Tillbaka",
            return: "Återgå",
            renew: "Förnya",
            ready: "Klar",
            configure: "Konfigurera",
            details: "Detaljer",
            loading: "Laddar...",
            hello: "Hej {name}",
            overrideAppVersion: "Åsidosätt appversion"
        },
        error: {
            fourOFour: "404 Sidan hittades inte"
        },
        nav: {
            home: {
                title: "Hem"
            },
            content: {
                title: "Innehåll",
                description:
                    "Massageprogram, träningsprogram, kategorier, statiska sidor och gränssnittsspråk."
            },
            markets: {
                title: "Marknader",
                description:
                    "Uppdelning och separation av olika områden, även kallade marknader."
            },
            chairs: {
                title: "Stolar",
                description: "Nya stolar, gamla stolar och alla andra stolar."
            },
            customers: {
                title: "Kunder",
                description: "Data, data och mer data om kunder"
            },
            sellers: {
                title: "Säljare",
                description: "Data, data och mer data om säljare"
            },
            users: {
                title: "Användare",
                description: "Användare av systemet"
            },
            docs: {
                title: "Dokumentation",
                description: "Guider och dokumentation för Promas."
            },
            admin: {
                title: "Admin",
                description: "Administrera vem som kan administrera Promas Admin."
            }
        }
    },
    chairState: {
        storage: "På lager",
        service: "På service",
        customer: "Hos kund"
    }
};
